import {SearchLgIcon} from '@components/ui/icon/Icon.tsx'
import {StyledInputText} from '@components/commons/table-input-search/style.ts'
import {InputTextProps} from '@components/commons/input-text/InputText.tsx'
import {useTheme} from 'styled-components'
import {forwardRef} from 'react'

interface TableInputSearchProps {
    defaultValue: InputTextProps['defaultValue']
    onChange: InputTextProps['onChange']
    placeholder: InputTextProps['placeholder']
}
export const TableInputSearch = forwardRef<HTMLInputElement, TableInputSearchProps>(
    ({defaultValue, onChange, placeholder}, ref) => {
        const theme = useTheme()

        return (
            <StyledInputText
                ref={ref}
                defaultValue={defaultValue}
                type="text"
                inputSize="sm"
                typeIcon={<SearchLgIcon size={16} fill={theme.palette.neutral['500']} />}
                onChange={onChange}
                placeholder={placeholder}
            />
        )
    }
)
